// PATH: src/api/uploadApi.ts
import { useApiClient } from "./apiClients";

interface UploadResponse {
  url: string;
  bucket: string;
  object: string;
  type: string;
}

export const useUploadApi = () => {
  const uploadClient = useApiClient("upload");

  const uploadMedia = async (file: File, path: string): Promise<string> => {
    const formData = new FormData();
    formData.append("file", file);
    const resp = await uploadClient.post<UploadResponse>(
      `/media?type=image&path=${encodeURIComponent(path)}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return resp.data.url;
  };

  return { uploadMedia };
};
